import { Button } from './ui/button';

/**
 * Pagination strip matching the Ecowater Cloud aesthetic.
 * Server-paginated APIs pass `total` & `totalPages`; client-paginated callers
 * can omit `totalPages` and we derive it.
 */
export function DataPagination({
  page,
  pageSize,
  total,
  totalPages: providedTotalPages,
  onPageChange,
  onPageSizeChange,
  pageSizes = [8, 16, 32, 64],
  testId = 'pagination',
}) {
  const totalPages = providedTotalPages ?? Math.max(1, Math.ceil((total || 0) / (pageSize || 1)));
  const safePage = Math.min(page, totalPages);
  const pageStart = !total ? 0 : (safePage - 1) * pageSize + 1;
  const pageEnd = Math.min(safePage * pageSize, total || 0);

  if (!total) return null;

  return (
    <div className="flex items-center justify-between bg-[#FFFFFF] border border-[#EDE6D8] rounded-2xl px-4 py-2.5" data-testid={testId}>
      <p className="text-xs text-[#78716C]" style={{ fontFamily: 'JetBrains Mono, monospace' }} data-testid={`${testId}-info`}>
        {pageStart}–{pageEnd} of {Number(total).toLocaleString()}
      </p>
      <div className="flex items-center gap-3">
        <select
          value={String(pageSize)}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="h-8 rounded-lg border border-[#EDE6D8] bg-[#FFFFFF] px-2 text-xs text-[#1C1917] focus:outline-none focus:border-[#0A2540]"
          data-testid={`${testId}-size`}
          style={{ fontFamily: 'JetBrains Mono, monospace' }}
        >
          {pageSizes.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
        <Button
          variant="outline"
          size="sm"
          disabled={safePage <= 1}
          onClick={() => onPageChange(Math.max(1, safePage - 1))}
          className="border-[#EDE6D8] rounded-lg"
          data-testid={`${testId}-prev`}
        >
          Prev
        </Button>
        <span className="text-xs text-[#1C1917] px-2" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
          {safePage} / {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={safePage >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, safePage + 1))}
          className="border-[#EDE6D8] rounded-lg"
          data-testid={`${testId}-next`}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
